import { makeStyles } from '@material-ui/core'

export const useTrialDashboardPageStyles = makeStyles((theme) => ({
  basePage: {
    overflow: 'visible !important',
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      overflow: 'visible !important',
      maxWidth: '100% !important',
      width: '100% !important',
      paddingLeft: 0,
      paddingRight: 0
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: '0 !important',
      paddingRight: '0 !important'
    }
  }
}))
